/* GET CALL_PRICES */
export const GET_CALL_PRICES = "GET_CALL_PRICES"
export const GET_CALL_PRICES_SUCCESS = "GET_CALL_PRICES_SUCCESS"
export const GET_CALL_PRICES_ERROR = "GET_CALL_PRICES_ERROR"
